import endpoints from "../utils/endpoints"
import { Api } from "./api"
import { notificationError, notificationSucces } from "./notification"

export async function getJackpotPaymentsList() {
  let res = {
    past_jackpot_payments: [
      {
        bingo_jackpot_payroll_id: "",
        id: {
          round: "",
          card: "",
          jackpot: ""
        },
        winner: {
          name: "",
          address: "",
          address2: "",
          addr_zipcode: "",
          addr_city: "",
          addr_state: "",
          addr_country: "",
          identification: "",
          state_of_id: "",
          phone_number: "",
          email:"",
          ssn: ""
        },
        jackpot_information: {
          prize: "",
          prize_time: "",
          paid_time: "",
          name: "",
          location: ""
        }
      }
    ],
    pending_jackpot_payments: [
      {
        bingo_jackpot_payroll_id: "",
        id: {
          round: "",
          card: "",
          jackpot: ""
        },
        device: "",
        location: "",
        prize: "",
        prize_time: ""
      }
    ]
  }
  await Api.get(endpoints.getJackpotPaymentsList).then((response) => {
    if (response.status === 200 && response.data) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get jackpots list')
    }
  }).catch((err: string) => {
    notificationError('Could not get jackpots list')
  })

  return res
}

export async function getJackpotPastPaymentById(params: any) {
  let res = {
    bingo_jackpot_payroll_id: "",
    id: {
      round: "",
      card: "",
      jackpot: ""
    },
    winner: {
      name: "",
      address: "",
      address2: "",
      addr_zipcode: "",
      addr_city: "",
      addr_state: "",
      addr_country: "",
      identification: "",
      state_of_id: "",
      phone_number: "",
      email:"",
      bar_affiliation: 0,
      org_affiliation: 0,
      birth_date: "",
      comments: "",
      ssn: ""
    },
    jackpot_information: {
      prize: "",
      prize_time: "",
      paid_time: "",
      name: "",
      location: ""
    }
  }
  await Api.get(endpoints.getJackpotPastPaymentById, {params}).then((response) => {
    if (response.status === 200 && response.data) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get jackpot payment info')
    }
  }).catch((err: string) => {
    notificationError('Could not get jackpot payment info')
  })

  return res
}

export async function getJackpotPendingPaymentById(params: any) {
  let res = {
    bingo_jackpot_payroll_id: "",
    id: {
      round: "",
      card: "",
      jackpot: ""
    },
    device: "",
    location: "",
    prize: "",
    prize_time: ""
  }
  await Api.get(endpoints.getJackpotPendingPaymentById, {params}).then((response) => {
    if (response.status === 200 && response.data) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get jackpot payment info')
    }
  }).catch((err: string) => {
    notificationError('Could not get jackpot payment info')
  })

  return res
}

export async function saveJackpotPayment(params: any) {
  let res = false
  await Api.post(endpoints.saveJackpotPayment, params).then((response) => {
    if (response.status === 200 && response.data) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = true
        notificationSucces('Jackpot payment saved')
      }
    } else {
      notificationError('Could not save jackpot payment info')
    }
  }).catch((err: string) => {
    notificationError('Could not save jackpot payment info')
  })

  return res
}
